import { render, staticRenderFns } from "./CollectionByIdForm.vue?vue&type=template&id=10c72cfa&scoped=true&"
import script from "./CollectionByIdForm.vue?vue&type=script&lang=js&"
export * from "./CollectionByIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c72cfa",
  null
  
)

export default component.exports